import type { ConfirmDepositInput } from '@repo/api-contracts';
import { useInvalidateOrders } from '@/entities/order';
import { useInvalidatePayments } from '@/entities/payment';
import { trpc } from '@/shared/api';

export const useConfirmDeposit = (): ((input: ConfirmDepositInput) => Promise<void>) => {
  const mutation = trpc.paymentManagement.confirmDeposit.useMutation();
  const orders = useInvalidateOrders();
  const payments = useInvalidatePayments();
  return async (input) => {
    await mutation.mutateAsync(input);
    await Promise.all([orders.detail(input.orderId), orders.list(), payments.list()]);
  };
};
